import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { ToastController, NavController, AlertController } from '@ionic/angular';
import { AlterarSenhaViewModel } from './AlterarSenhaViewModel';
import { AlterarSenhaModel } from 'projects/core/src/lib/core/model/AlterarSenhaModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';

@Component({
  selector: 'alterar-senha-page',
  templateUrl: 'alterar-senha.page.html',
  styleUrls: ['alterar-senha.page.scss']
})
export class AlterarSenhaPage extends BasePage {
  constructor(
    public router: Router, 
    public toastCtrl: ToastController, 
    private navCtrl: NavController,
    public alertController: AlertController) {
      super(router)
  }

  emRequisicao: Boolean = false
  alterarSenhaViewModel: AlterarSenhaViewModel
  alterarSenhaModel: AlterarSenhaModel
  alertComponent: AlertComponent

  ngOnInit() {
    this.inicializarVariaveis()
  }

  inicializarVariaveis() {
    this.alterarSenhaModel = new AlterarSenhaModel()
    this.alterarSenhaViewModel = new AlterarSenhaViewModel()
    this.alterarSenhaViewModel.setContext(this)
  }

  async enviaAlterarSenha() {
    try {
      this.emRequisicao = true
      await this.alterarSenhaViewModel.enviaAlterarSenha(this.alterarSenhaModel)
    } catch(e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT, () => {
        this.navCtrl.pop()
      })
    }
    setTimeout(() => {
      this.emRequisicao = false
    }, 1000)
  }

  validaSenhas() {
    if (!this.alterarSenhaModel.senha_antiga || this.alterarSenhaModel.senha_antiga == '') {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "senha atual"')
      return false
    }

    if (!this.alterarSenhaModel.senha_nova || this.alterarSenhaModel.senha_nova == '') {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "nova senha"')
      return false
    }

    if (!this.alterarSenhaModel.confirmarSenha || this.alterarSenhaModel.confirmarSenha == '') {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "confirmar senha"')
      return false
    }

    if (this.alterarSenhaModel.senha_nova != this.alterarSenhaModel.confirmarSenha) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'O campo "nova senha" e "confirmar senha" devem ser iguais')
      return false
    }

    if (this.alterarSenhaModel.senha_antiga == this.alterarSenhaModel.confirmarSenha) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'A nova senha deve ser diferente da senha atual')
      return false
    }
    return true
  }

  btnAlterarSenha() {
    if (this.validaSenhas()) {
      this.enviaAlterarSenha()
    }
  }

  mensagemSucessoAlteracao(message: string) {
    this.showToast(message)
    this.navCtrl.back();
  }

  mensagemFalhaAlteracao(message: string) {
    this.showToast(message)
  }

  async showToast(message: string) {
    let toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
}
